import {banks_api} from "@/store/resources"

export default {
    namespaced: true,
    state: {
        banksList: {
            data: [],
            dirty: false
        },
        providers: {
            data: [],
            dirty: false
        }
    },
    getters: {
        availableBanksList: (state) => state.banksList.data.filter(bank => bank.country_code !== 'XO'),
        availablePaymentSystemsList: (state) => state.banksList.data.filter(bank => bank.country_code === 'XO'),
        banksProviders: (state) => state.providers.data.filter(provider => provider.bank.country_code !== 'XO'),
        paymentSystemsProviders: (state) => state.providers.data.filter(provider => provider.bank.country_code === 'XO'),
    },
    actions: {
        async fetchBanksList({commit}) {
            try {
                const res = await banks_api.banksList.get();
                if (res.body.success) {
                    commit('storeBanksList', res.body.data)
                } else {
                    console.error(res)
                }
            } catch (err) {
                console.error(err)
            }
        },
        async fetchProviders({commit, rootState}) {
            try {
                const space_id = rootState.space.current_space.data.id;
                const res = await banks_api.banksConnections.save({space_id});
                if (!!res.body) {
                    const spaceAccounts = rootState.space.accounts.accounts.data;
                    commit('storeProviders', {providers: res.body.data, spaceAccounts})
                } else {
                    console.error(res)
                }
            } catch (err) {
                console.error(err)
            }
        },
        connectBank({commit}, data) {
            return banks_api.connectBank.save({...data})
        },
        disconnectProvider({commit}, data) {
            return banks_api.disconnectBank.save({...data})
        },
        refreshProvider({}, {space_id, connection_id}) {
            return banks_api.refreshBankConnection.save({space_id, connection_id})
        },
        connectAccounts({}, data) {
            return banks_api.connectAccounts.save(data);
        },
    },
    mutations: {
        storeBanksList(state, banks) {
            state.banksList.data = banks;
            state.banksList.dirty = false;
        },
        storeProviders(state, {providers, spaceAccounts}) {
            // сопоставляем счета в провайдерах со счетами спейса
            for (let provider of providers) {
                let {accounts: providersAccounts} = provider;
                providersAccounts.map((pAccount) => {
                    pAccount.connected_to = spaceAccounts.find(sAccount => sAccount.import_id === pAccount.uid) || null;
                    pAccount.enabled = !!pAccount.connected_to;
                })
            }

            state.providers.data = providers;
            state.providers.dirty = false;
        },
        clearProviders(state) {
            state.providers.data = [];
            state.providers.dirty = false;
        }
    }
}